<template>
  <div
    class="reserve position-relative d-flex flex-flow-column align-items-center"
  >
    <img
      src="../../assets/img/reserve/title.png"
      alt=""
      srcset=""
      class="title"
    />

    <div class="defaultImg progress-size" v-if="preview < 50000"></div>
    <div v-else>
      <div v-for="(value, fKey) in previewList" :key="fKey" class="mt-12">
        <div
          class="progress-size"
          :class="[
            'item' + (fKey + 1),
            preview >= value &&
            (fKey + 1 === previewList.length || preview < previewList[fKey + 1])
              ? 'pimg-block'
              : 'pimg-none'
          ]"
        ></div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      preview: 0,
      previewList: [50000, 150000, 250000, 350000, 500000] // 卡片
    };
  },

  created() {
    this.initData();
  },
  methods: {
    // info 接口获取数据
    // id  341
    initData() {
      const reqTime = Math.floor(new Date().getTime() / 1000);
      let url = window.location.search;
      let preview = "unknow";
      let previewParam =
        url.indexOf("preview") >= 0
          ? this.common.getUrlParam("preview").slice(0, -2)
          : this.common.getUrlParam("preview");
      preview = previewParam || "unknow";

      this.$axios({
        method: "post",
        url: "/doragenai/info",
        data: {
          //get这里应为params
          //请求参数
          signature: this.common.makeSignature({}, reqTime),
          reqTime: reqTime,
          preview: preview
        },
        //withCredentials:true, //局部携带cookie
        headers: {} //如果需要添加请求头可在这写
      })
        .then(res => {
          this.preview = res.data.data.register;
        })
        .catch(err => {
          //请求失败就会捕获报错信息
          //err.response可拿到服务器返回的报错数据
        });
    }
  }
};
</script>
<style lang="scss">
.reserve {
  height: 1080px;
  width: 100%;

  background-image: url("../../assets/img/reserve/bg.png");
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  position: relative;

  .title {
    width: 787px;
    height: auto;
    padding-top: 10vw;
  }

  .progress-size {
    width: 1200px;
    height: 750px;
    margin-top: 4vw;
  
  }

  .defaultImg {
    background: url("../../assets/img/reserve/defaultImg.png") no-repeat center
      top;
    background-size: 100% 100%;
  }

  .item1 {
    background: url("../../assets/img/reserve/line-5.png") no-repeat center top;
    background-size: 100% 100%;
  }

  .item2 {
    background: url("../../assets/img/reserve/line-15.png") no-repeat center top;
    background-size: 100% 100%;
  }

  .item3 {
    background: url("../../assets/img/reserve/line-25.png") no-repeat center top;
    background-size: 100% 100%;
  }

  .item4 {
    background: url("../../assets/img/reserve/line-35.png") no-repeat center top;
    background-size: 100% 100%;
  }

  .item5 {
    background: url("../../assets/img/reserve/line-50.png") no-repeat center top;
    background-size: 100% 100%;
  }

  .pimg-none {
    display: none;
  }

  .pimg-block {
    display: block;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/mainComponents/reserve.vue